import { Text } from '@launchpad-ui/components';

import { HealthCheckIcon } from '../HealthCheckIcon';
import type { HealthCheckStatus } from '../types';

import styles from '../HealthCheck.module.css';

/** Single list item in Health Check Popover with icon and text indicating the state. */
export function HealthCheckItem({ status, children }: { status: HealthCheckStatus; children: React.ReactNode }) {
  return (
    <div className={styles.healthCheckItem}>
      <div className={styles.healthCheckItemIcon}>
        <HealthCheckIcon status={status} />
      </div>
      <Text slot="subtitle" className={styles.healthCheckItemText}>
        {children}
      </Text>
    </div>
  );
}
